export default __webpack_public_path__ + "static/media/Musizierende-Katzen.cf2f4aab.webp";